import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import myUtil from '@/tools/myUtil';
import router from './router'
import store from './store'
import AMap from 'vue-amap'
import axios from 'axios'

Vue.use(AMap)

// 初始化地图
AMap.initAMapApiLoader({
  key: '3b1bba739064f83e2a0370204f7c2ce7',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  v: '2.0'})

Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.$myUtil = myUtil;
Vue.use(ElementUI);
Vue.filter('formatter', function(value, arg) {
	function dataFormat(date, format) {
		if (typeof date === "string") {
			var mts = date.match(/(\/Date\((\d+)\)\/)/);
			if (mts && mts.length >= 3) {
				date = parseInt(mts[2]);
			}
		}
		date = new Date(date);
		if (!date || date.toUTCString() == "Invalid Date") {
			return "";
		}
		var map = {
			"M": date.getMonth() + 1,
			"d": date.getDate(),
			"h": date.getHours(),
			"m": date.getMinutes(),
			"s": date.getSeconds(),
			"q": Math.floor((date.getMonth() + 3) / 3),
			"S": date.getMilliseconds()
		};
		format = format.replace(/([yMdhmsqS])+/g, function(all, t) {
			var v = map[t];
			if (v !== undefined) {
				if (all.length > 1) {
					v = '0' + v;
					v = v.substr(v.length - 2);
				}
				return v;
			} else if (t === 'y') {
				return (date.getFullYear() + '').substr(4 - all.length);
			}
			return all
		});
		return format;
	}
	return dataFormat(value, arg);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
